import {VehicleLogFilterTypeEnum} from '@/enums/vehicle-log-filter-type.enum';

export function vehicleLogSortingTypeColorTextFilter(type: VehicleLogFilterTypeEnum) {
  switch (type) {
    case VehicleLogFilterTypeEnum.InWorkshop: return 'indigo--text text--darken-4';
    case VehicleLogFilterTypeEnum.Theft: return 'error--text';
    case VehicleLogFilterTypeEnum.NotPaid: return 'warning--text';
    case VehicleLogFilterTypeEnum.NotRentedReadyToWork: return 'success--text';
    case VehicleLogFilterTypeEnum.RentedAndPaid: return 'primary--text';
    case VehicleLogFilterTypeEnum.PrePaymentRent: return 'teal--text';
    default: return '';
  }
}
